var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var ChatController = /** @class */ (function () {
    function ChatController() {
    }
    /*****************************************************************************************************
        * Is using route "api/chat" and http method "GET" to call the back-end.
    
        * @returns {ChatDownloadDto[]}
    ******************************************************************************************************/
    ChatController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/unseen" and http method "GET" to call the back-end.
    
        * @returns {number}
    ******************************************************************************************************/
    ChatController.GetChatUnseenMessages = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/unseen", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/{id}/members/count" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {number}
    ******************************************************************************************************/
    ChatController.GetChatMembersCount = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/{id}/members/count", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/{id}/members" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {UserShortInfoDownloadDto[]}
    ******************************************************************************************************/
    ChatController.GetChatMembers = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/{id}/members", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/promote/{chatid}/{id}" and http method "POST" to call the back-end.
    
        * @param {string} chatid
        * @param {string} id
        * @returns {ChatDownloadDto}
    ******************************************************************************************************/
    ChatController.PromoteChatMember = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/promote/{chatid}/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/demote/{chatid}/{id}" and http method "POST" to call the back-end.
    
        * @param {string} chatid
        * @param {string} id
        * @returns {ChatDownloadDto}
    ******************************************************************************************************/
    ChatController.DemoteChatMember = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/demote/{chatid}/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ChatDownloadDto}
    ******************************************************************************************************/
    ChatController.GetById = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/{id}/token" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {TokenContainer} token
        * @returns {ChatMessagesDownloadDto}
    ******************************************************************************************************/
    ChatController.GetChatMessages = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/{id}/token", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {ChatMessageUploadDto} message
        * @param {File} media
        * @returns {ChatMessageDownloadDto}
    ******************************************************************************************************/
    ChatController.SendMessage = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("message", JSON.stringify(data.message));
        if (data.media)
            fd.append("media", data.media);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {ChatUploadDto} chat
        * @param {File} avatar
        * @returns {ChatDownloadDto}
    ******************************************************************************************************/
    ChatController.PatchChat = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("chat", JSON.stringify(data.chat));
        if (data.avatar)
            fd.append("avatar", data.avatar);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/{id}/user" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string[]} userIds
        * @returns {ChatMessageDownloadDto}
    ******************************************************************************************************/
    ChatController.AddUserToChat = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/{id}/user", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.userIds
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/with/user" and http method "POST" to call the back-end.
    
        * @param {string[]} userIds
        * @param {ChatUploadDto} chat
        * @param {File} avatar
        * @returns {ChatDownloadDto}
    ******************************************************************************************************/
    ChatController.CreateChatWithUser = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("userIds", JSON.stringify(data.userIds));
        fd.append("chat", JSON.stringify(data.chat));
        if (data.avatar)
            fd.append("avatar", data.avatar);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/with/user", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/{id}/user/{userid}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @param {string} userid
        * @returns {ChatMessageDownloadDto}
    ******************************************************************************************************/
    ChatController.DeleteChatUser = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/{id}/user/{userid}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/chat/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {ChatMessageDownloadDto}
    ******************************************************************************************************/
    ChatController.DeleteChat = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/chat/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return ChatController;
}());
export { ChatController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=ChatController.js.map